import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { EntityService } from "../../services/entity.service";
import { environment } from "../../../environments/environment";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  isLoading = false;
  showSuccessModal = false;

  constructor(
    private fb: FormBuilder,
    private entityService: EntityService,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.valid) {
      const data = {
        email: this.forgotPasswordForm.value.email,
        url_base: environment.baseUrl,
      };
      console.log(data);
      this.isLoading = true;
      this.entityService
        .justSave("/users/reset-password/request", data)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.showSuccessModal = true;
          },
          error: (error) => {
            this.notificationService.error(
              error.error.message ||
                "Une erreur est survenue lors de l'envoi de l'email",
              "Erreur"
            );
            this.isLoading = false;
          },
        });
    }
  }

  closeModalAndRedirect() {
    this.showSuccessModal = false;
    this.router.navigate(["/auth/login"]);
  }
}
